/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios';
import {computePlannedStatus} from "../hooks/useComputeStatus";
import GetPMCallPages, { pmCallPagesEnabled } from "./GetPMCallPagesFunction";

import { TOKEN_EXPIRED, TIMEOUT, INTERNAL_ERROR } from "../hooks/useAPIHelper";

const GET_REACTIVE_JOBS_URL = '/.netlify/functions/xServiceGetPMCalls';

//TODO: Remove for refactoring

const GetPMCallsFunction = async (filter: string, token: string, selectedCustomerId: string, firstPageOnly: boolean = false) => {

  // The whole-customer list may come from paged files instead (PORTAL-72). Off unless this browser
  // or this build opted in, and anything it cannot do returns null and falls through to the call
  // below - which is unchanged.
  if (filter === '' && pmCallPagesEnabled()) {
    const fromPages = await GetPMCallPages(token, selectedCustomerId, firstPageOnly);

    if (fromPages !== null) {
      return computePlannedStatus(fromPages as any);
    }
  }

  const fetchData = async(): Promise<any> => {
    try {
      let PMCallResponse = await axios.post(GET_REACTIVE_JOBS_URL,
        `<Filters><CustomerCode><Like>${selectedCustomerId}</Like></CustomerCode>${filter}</Filters>`
        , {
          headers: {
            'Content-Type': 'application/xml',
            'X-Pronto-Token': token,
          },
        });

      if (PMCallResponse.status === 200) {
        const jobs = PMCallResponse.data.ServiceGetPMCallsResponse.ServicePMCalls.ServicePMCall;

        if (Array.isArray(jobs)) {
          let filteredJobs = computePlannedStatus(jobs);
          return filteredJobs;
        } else {
          if (jobs == undefined) return [];
          let filteredJob = computePlannedStatus([jobs]);
          return filteredJob;
        }

      } else {
        return [];
      }

    } catch (err) {
      if(err.response.status == 401) {
        if(err.response.data == 'TokenExpired') {
          throw(TOKEN_EXPIRED)
        }
      } else if(err.response.status == 504) {
        throw(TIMEOUT)
      } else if(err.response.status == 500) {
        throw(INTERNAL_ERROR);
      }
    }
  };

  return await fetchData();
};

export default GetPMCallsFunction;
